<template>
    <Banner />
    <div id="main-view">
        <router-view />
    </div>
</template>

<script lang="ts">
import "@/modules/toggle-log";
import Banner from "@/components/Banner.vue";
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { autoThemeSetup } from "@/modules/theme";

console.setEnable(process.env.NODE_ENV !== "production");
console.log(`Runtime Environment: ${process.env.NODE_ENV}`);

export default defineComponent({
    components: {
        Banner
    },
    setup() {
        useRouter().beforeEach((to, from, next) => {
            const defaultDescription = "CoderJo's Website";
            const defaultTitle = "CoderJo's Website";

            document.title = "CoderJo - " + (to.meta.title || defaultTitle);

            const crawlDescription: any = document.getElementById("crawl-description");
            const crawlDescriptionMeta: any = document.getElementById("crawl-description-meta");
            crawlDescription.innerText = to.meta.description ?? defaultDescription;
            crawlDescriptionMeta.content = to.meta.description ?? defaultDescription;
            
            next();
        });

        const i18n = useI18n();
        const language = navigator.language;

        if (i18n.availableLocales.includes(language)) {
            i18n.locale.value = language;
        } else {
            const languages = navigator.languages;
            const availPrefer = i18n.availableLocales.filter(item => languages.includes(item))[0];
            if (availPrefer) {
                i18n.locale.value = availPrefer;
            }
        }
    },
    mounted() {
        autoThemeSetup();
    }
});
</script>

<style src="@/css/main.css"></style>
